export const productsActionTypes = {
	CREATE_PRODUCT: "CREATE_PRODUCT",
	GET_ALL_PRODUCTS: "GET_ALL_PRODUCTS",
	GET_SINGLE_PRODUCT: "GET_SINGLE_PRODUCT",
};
